<script>
import { settings } from '../src/data_storage.js'
settings.useLocalStorage()

import { _, locale, locales } from 'svelte-i18n'

function saveLocale() {
  console.log('saveLocale' + $_('currency'))
  $settings.locale = locale
  $settings.currency = $_('currency')
}
</script>

<select bind:value={$locale} on:change={saveLocale} class="rounded-md drop-shadow-md hover:bg-gray-100 focus:ring-0 {$$restProps.class || ''}">
  {#each $locales as locale}
    <option value={locale}>{$_('currency', {locale: locale})}</option>
  {/each}
</select>
